import { Skeleton } from '@/components/ui/skeleton';

const WebSessionItemSkeleton = () => (
  <div className="flex w-full items-center gap-4 rounded-lg border border-border bg-background px-4 py-4">
    <Skeleton className="h-12 w-12 shrink-0 rounded" />
    <div className="flex flex-1 flex-col justify-center gap-1">
      <Skeleton className="h-5 w-32" />
      <Skeleton className="h-3 w-24" />
    </div>
    <Skeleton className="h-6 w-6 rounded" />
  </div>
);

export default WebSessionItemSkeleton;
